// Централизованные константы статистики для всего сайта
// Изменяйте значения здесь, и они обновятся везде

export const COMPANY_STATS = {
  // Основная статистика
  // processedCars: '100+',
  yearsOfWarranty: '5+',
  yearsOfExperience: '3+',
  satisfiedClients: '98%',
  processingTypes: '3+',

  // Дополнительная статистика
  warrantyYears: '3',
  discountPercent: '10',
  freeDiagnostic: true,

  // Контактная информация
  phone: '+375 (33) 666-51-22',
  phoneClean: '+375336665122',
  address: 'г. Брест, ул. Мощенского, 90',
  workingHours: {
    weekdays: '9:00-18:00',
    saturday: '9:00-15:00',
    sunday: 'Выходной'
  },

  // Год основания
  foundedYear: '2022',
  currentYear: new Date().getFullYear()
}

// Статистика для Hero секции
export const HERO_STATS = [
  {
    icon: 'Car',
    value: COMPANY_STATS.yearsOfWarranty,
    label: 'Года гарантии'
  },
  {
    icon: 'Shield',
    value: COMPANY_STATS.yearsOfExperience,
    label: 'Года опыта'
  },
  {
    icon: 'Star',
    value: COMPANY_STATS.satisfiedClients,
    label: 'Довольных клиентов'
  }
]

// Статистика для WhyChooseUs секции
export const WHY_CHOOSE_US_STATS = [
  {
    icon: 'Car',
    value: COMPANY_STATS.yearsOfWarranty,
    label: 'Года гарантии'
  },
  {
    icon: 'Shield',
    value: COMPANY_STATS.yearsOfExperience,
    label: 'Года успешной работы'
  },
  {
    icon: 'Star',
    value: COMPANY_STATS.satisfiedClients,
    label: 'Довольных клиентов'
  }
]

// Статистика для Gallery страницы
export const GALLERY_STATS = [
  {
    number: COMPANY_STATS.yearsOfWarranty,
    label: 'Года гарантии'
  },
  {
    number: COMPANY_STATS.processingTypes,
    label: 'Вида обработки'
  },
  {
    number: COMPANY_STATS.satisfiedClients,
    label: 'Довольных клиентов'
  },
  {
    number: COMPANY_STATS.yearsOfExperience,
    label: 'Года опыта'
  }
]

// Статистика для About страницы
export const ABOUT_STATS = [
  {
    icon: 'Shield',
    value: COMPANY_STATS.yearsOfExperience,
    label: 'Лет опыта'
  },
  {
    icon: 'Star',
    value: COMPANY_STATS.satisfiedClients,
    label: 'Довольных клиентов'
  },
  {
    icon: 'Award',
    value: COMPANY_STATS.yearsOfWarranty,
    label: 'Года гарантии'
  }
]

// Контактная информация для всех компонентов
export const CONTACT_INFO = [
  {
    icon: 'Phone',
    title: 'Телефон',
    value: COMPANY_STATS.phone,
    description: 'Звоните в любое время',
    action: `tel:${COMPANY_STATS.phoneClean}`
  },
  {
    icon: 'MapPin',
    title: 'Адрес',
    value: COMPANY_STATS.address,
    description: 'Приезжайте к нам',
    action: 'https://maps.google.com'
  },
  {
    icon: 'Clock',
    title: 'Режим работы',
    value: `Пн-Пт: ${COMPANY_STATS.workingHours.weekdays}`,
    description: `Сб: ${COMPANY_STATS.workingHours.saturday}`,
    action: null
  }
]

// Контактная информация для CTA секции
export const CTA_CONTACT_INFO = [
  {
    icon: 'Phone',
    title: 'Телефон',
    value: COMPANY_STATS.phone,
    description: 'Звоните в любое время',
    action: `tel:${COMPANY_STATS.phoneClean}`
  },
  {
    icon: 'Clock',
    title: 'Режим работы',
    value: `Пн-Пт: ${COMPANY_STATS.workingHours.weekdays}`,
    description: `Сб: ${COMPANY_STATS.workingHours.saturday}`,
    action: null
  },
  {
    icon: 'MapPin',
    title: 'Адрес',
    value: COMPANY_STATS.address,
    description: 'Удобное расположение',
    action: null
  }
]

// Статистика для Testimonials секции
export const TESTIMONIALS_STATS = [
  {
    number: COMPANY_STATS.yearsOfWarranty,
    label: 'Года гарантии'
  },
  {
    number: COMPANY_STATS.satisfiedClients,
    label: 'Положительных отзывов'
  },
  {
    number: '5.0',
    label: 'Средняя оценка'
  }
]
